import styled, { css } from 'styled-components';
import { ITheme } from '../../../styles/theme';
import { DropdownContainer, SelectedOption, StyledDropdown } from '../UIHelpersLUXE/Dropdown/DropdownLUXE-styled';


export const TabHeader = styled.div`
	display: flex;
	justify-content: center;
	text-transform: uppercase;
	font-size: 32px;
  font-weight: bold;
	margin-bottom: 30px;
`;

export const TabRow = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	position: relative;
`;

export const TabElementLabel = styled.div`
	flex-basis: 100%;
	margin: 3px;
	font-size: 12px;
`;

export const TabContainer = styled.div<{mobile:boolean, menuHeight:number, menuScaleFactor:number}>`
	${(props) => props.mobile && css`
    ${TabHeader} {
      font-size: ${12 * props.menuScaleFactor}px;
    };

		${TabElementLabel} {
			font-size: ${12 * props.menuScaleFactor}px;
		};

		${DropdownContainer} {
			font-size: ${14 * props.menuScaleFactor}px;
			height: ${44 * props.menuScaleFactor}px;
		};

		${StyledDropdown} {
			padding: 0px ${12 * props.menuScaleFactor}px;
		};

		${SelectedOption} svg {
			width: ${10 * props.menuScaleFactor}px;
			height: ${18 * props.menuScaleFactor}px;
			right: ${18 * props.menuScaleFactor}px;
			bottom: ${14 * props.menuScaleFactor}px;	
		};

		${TabHeader} {
			margin-bottom: ${20 * props.menuScaleFactor}px;
    };
  `};
`;